module.exports = __webpack_public_path__ + "images/emoji/mailbox.780e4d590a037be5af78.png";